/**
 * Default only explicitly marked collection Quick Views to their advertised
 * Appstle plan. Use Appstle's own controls so its prices and cart fields agree.
 * Do not change app-wide defaults or override a shopper's subsequent choice.
 */
(() => {
  if (window.sukkerSubscriptionCollectionBound) return;
  window.sukkerSubscriptionCollectionBound = true;

  const initialized = new WeakSet();

  document.addEventListener('sukker:quick-view-ready', ({ detail }) => {
    const { modal, trigger } = detail;
    const planId = trigger?.dataset.subscriptionPlan;
    if (!planId || !modal || initialized.has(modal)) return;

    let stopped = false;
    let timer;
    const stop = () => {
      stopped = true;
      observer.disconnect();
      clearTimeout(timer);
      modal.removeEventListener('change', onShopperChange, true);
    };
    const onShopperChange = (event) => {
      if (event.isTrusted && event.target.closest('.appstle_sub_widget')) {
        initialized.add(modal);
        stop();
      }
    };
    const selectPlan = () => {
      if (stopped) return;
      if (!modal.isConnected) return stop();
      const form = modal.querySelector('form[data-type="add-to-cart-form"]');
      if (!form) return;

      const radios = [...form.querySelectorAll('input[type="radio"][name="selling_plan"]')];
      let radio = radios.find((input) => input.value === planId);
      let frequency;
      if (!radio) {
        // Appstle can group multiple frequencies under a single purchase option.
        frequency = [...form.querySelectorAll('select.appstle_select')]
          .find((select) => [...select.options].some((option) => option.value === planId));
        radio = frequency?.closest('.appstle_subscription_wrapper_option')
          ?.querySelector('input[type="radio"][name="selling_plan"]');
      }
      if (!radio || radio.disabled) return;

      // Disconnect before clicking: Appstle changes its own DOM synchronously.
      stop();
      radio.click();
      if (frequency && frequency.value !== planId) {
        frequency.value = planId;
        frequency.dispatchEvent(new Event('change', { bubbles: true }));
      }
      initialized.add(modal);
    };

    const observer = new MutationObserver(selectPlan);
    modal.addEventListener('change', onShopperChange, true);
    observer.observe(modal, { childList: true, subtree: true });
    timer = setTimeout(stop, 10000);
    selectPlan();
  });
})();
